import { render, staticRenderFns } from "./SelectBtn.vue?vue&type=template&id=332546fa"
import script from "./SelectBtn.vue?vue&type=script&lang=js"
export * from "./SelectBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports